module.exports = __webpack_public_path__ + "static/media/ru.4336677b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ru.svg
// module id = 1147
// module chunks = 0